import { createApiInstance } from './config';
import { createAdminApi } from '@/api/admin/admin.service.ts';
import { createBusinessPartnersApi } from '@/api/business-partner/business-partner.service.ts';
import { createItemsApi } from '@/api/items/items.service.ts';
import { createStockListsApi } from '@/api/stock-lists/stock-lists.service.ts';
import { createAuthApi } from '@/api/auth/auth.service.ts';
import { createCartsApi } from '@/api/carts/carts.service.ts';
import { createOrdersApi } from '@/api/orders/orders.service.ts';
import { createUserApi } from '@/api/user/user.service.ts';
import { createDocumentsApi } from '@/api/documents/documents.service.ts';
import { createVersionApi } from '@/api/version/version.service.ts';
import { createSupplierPriceListsApi } from '@/api/supplier-price-lists/supplier-price-lists.service.ts';
import { createPreisToolApi } from '@/api/preis-tool/preis-tool.service.ts';
import { createDashboardApi } from '@/api/dashboard/dashboard.service.ts';
import { createEmailSubscriptionsApi } from '@/api/email-subscriptions/email-subscriptions.service.ts';
import { createRolesApi } from '@/api/roles/roles.service.ts';
import { createEmailBuilderApi } from '@/api/email-builder/email-builder.service.ts';
import { createSourcingApi } from '@/api/sourcing/sourcing.service.ts';
import { createSpecificationsApi } from '@/api/specifications/specifications.service.ts';
import { createContactListsApi } from '@/api/contact-list/contact-list.service.ts';
import { createAiConversationsApi } from '@/api/ai-conversations/ai-conversations.service.ts';
import { createAppStateApi } from '@/api/app-state/app-state.service.ts';
import { createAnnouncementsApi } from '@/api/announcements/announcements.service.ts';

const api = createApiInstance();

export const adminApi = createAdminApi(api);
export const businessPartnersApi = createBusinessPartnersApi(api);
export const itemsApi = createItemsApi(api);
export const stockListsApi = createStockListsApi(api);
export const authApi = createAuthApi(api);
export const cartsApi = createCartsApi(api);
export const ordersApi = createOrdersApi(api);
export const documentsApi = createDocumentsApi(api);
export const usersApi = createUserApi(api);
export const versionApi = createVersionApi(api);
export const supplierPriceListsApi = createSupplierPriceListsApi(api);
export const preisToolApi = createPreisToolApi(api);
export const dashboardApi = createDashboardApi(api);
export const emailSubscriptionsApi = createEmailSubscriptionsApi(api);
export const rolesApi = createRolesApi(api);
export const emailBuilderApi = createEmailBuilderApi(api);
export const sourcingApi = createSourcingApi(api);
export const specificationsApi = createSpecificationsApi(api);
export const contactListsApi = createContactListsApi(api);
export const aiConversationsApi = createAiConversationsApi(api);
export const appStateApi = createAppStateApi(api);
export const announcementsApi = createAnnouncementsApi(api);
